<template>
  <div>
    <router-view class="fade-motion"></router-view>
  </div>
</template>

<script>
export default {
  name: "ClientView"
};
</script>
